import * as STD                            from '@emersya/mpa-std-lib';
import CM                                  from '@emersya/mpa-components-manager-lib';
import ViewerComponent                     from '../../../viewer/Viewer/Viewer';
import { NS as StandingPartitionsHeadsNS } from '../StandingPartitionsHeads/StandingPartitionsHeads';
import { NS as PlannerFurnitureEditorNS }  from '../../../viewer/planner/furniture/Editor/PlannerFurnitureEditor';

export interface IStandingFurnitureComponentConfiguration extends CM.Component.IConfiguration {
	// To not duplicate many property of the app configuration, and because this component is unique, retrieve conf directly from app and lets this interface be empty.
};

const mtx = (position : ViewerComponent.TVector3, rotation : number) => app.viewer.mtx(
	position,
	[ 1, 1, 1 ],
	rotation
);

export class StandingFurnitureComponent extends CM.Component<
	StandingFurnitureComponent,
	IStandingFurnitureComponentConfiguration
>
{
	static override initialize() {
		super.initialize();
	};

	readonly plannerCategory! : ViewerComponent.ProductCategory;
	// viewerNode : ViewerPlannerNS.TProductInstance[] | null = null;
	archDimensions : { width : number; depth : number; height : number } | null = null;

	getWDH() {
		const p = app.currentProduct;
		if (!p) {
			this.component_throwUserError('');
		}
		const dpart = p.getPart([ 'dimensions' ]);
		return {
			width :  Number.parseFloat(dpart.getPart([ 'width' ])?.reference?.value || <string> <any> 1),
			depth :  Number.parseFloat(dpart.getPart([ 'depth' ])?.reference?.value || <string> <any> 1),
			height : Number.parseFloat(dpart.getPart([ 'height' ])?.reference?.value || <string> <any> 1)
		};
	};

	getWallThickness() {
		// TODO : DEHARDCODE
		return 0.05;
	}

	getBusinessArchSizeStickToStorage() {
		// TODO : DEHARDCODE
		return 0.44;
	};

	getPrestigeArchSizeStickToStorage() {
		// TODO : DEHARDCODE
		return 0.44;
	};

	private computeMatrix(item : string) : ViewerComponent.TMatrix | null {
		const wdh = this.getWDH();
		const x = wdh.width;
		const y = wdh.height;
		const z = wdh.depth;
		void y;
		const surface = x * z;
		const product = app.currentProduct;
		if (!product) {
			throw STD.errors.user('No current product available in arch!');
		}
		const partitionsHeads = app.modules.used.find(x => x.id === 'standing-partitionsHeads');
		if (!partitionsHeads) {
			throw STD.errors.user('Partitions Heads not instanciate before arch');
		}
		const partitionHeadsComponent = <StandingPartitionsHeadsNS.Component> partitionsHeads.component;
		if (!partitionHeadsComponent) {
			throw STD.errors.user('Partitions Heads doesnt have component in arch');
		}
		// const boundingBoxPartitions = partitionHeadsComponent.isPartitionsHeads ? partitionHeadsComponent.partitionsWidth : 0;
		const layoutPart = product.getPart([ 'layout' ]);
		if (!layoutPart) {
			throw STD.errors.user('No part layout available in arch');
		}
		const layoutCurrentOption = layoutPart.currentOption;
		if (!layoutCurrentOption) {
			throw STD.errors.user('No current option in layout part in arch');
		}
		const layoutId = layoutCurrentOption.id;
		const highTable = app.component_configuration.productsComponents.find(x => x.type ===
			'@furniture' &&
			x.SKU ===
			'furniture-table');
		if (!highTable) {
			throw STD.errors.user('No high table furniture found');
		}
		const BBHighTable = highTable.boundingBox;
		if (!BBHighTable) {
			throw STD.errors.user('No bounding box for high table furniture found');
		}
		const counter = app.component_configuration.productsComponents.find(x => x.type === 'counter');
		if (!counter) {
			throw STD.errors.user('No counter found');
		}
		const BBCounter = counter.boundingBox;
		if (!BBCounter) {
			throw STD.errors.user('No bounding box for counter found');
		}
		const trash = app.component_configuration.productsComponents.find(x => x.type ===
			'@furniture' &&
			x.SKU ===
			'furniture-trash');
		if (!trash) {
			throw STD.errors.user('No trash found');
		}
		const BBTrash = trash.boundingBox;
		if (!BBTrash) {
			throw STD.errors.user('No bounding box for trash found');
		}
		if (product.id === 'business') {
			const archLeft = app.component_configuration.productsComponents.find(x => x.type ===
				'arch' &&
				x.SKU ===
				'arch-business-left');
			const archRight = app.component_configuration.productsComponents.find(x => x.type ===
				'arch' &&
				x.SKU ===
				'arch-business-right');
			const archSpecial = app.component_configuration.productsComponents.find(x => x.type ===
				'arch' &&
				x.SKU ===
				'arch-business-special');
			if (!archLeft || !archRight || !archSpecial) {
				throw STD.errors.user('No arch found');
			}
			const BBArchLeft = archLeft.boundingBox;
			const BBArchRight = archRight.boundingBox;
			const BBArchSpecial = archSpecial.boundingBox;
			if (!BBArchLeft || !BBArchRight || !BBArchSpecial) {
				throw STD.errors.user('Missing bounding box for an arch ');
			}
			const table = app.component_configuration.productsComponents.find(x => x.type ===
				'@furniture' &&
				x.SKU ===
				'furniture-table-basse');
			if (!table) {
				throw STD.errors.user('No table furniture found');
			}
			const BBTable = table.boundingBox;
			if (!BBTable) {
				throw STD.errors.user('No bounding box for table furniture found');
			}
			const briefcase = app.component_configuration.productsComponents.find(x => x.type ===
				'@furniture' &&
				x.SKU ===
				'furniture-briefcase-business');
			if (!briefcase) {
				throw STD.errors.user('No briefcase furniture found');
			}
			const BBBriefcase = briefcase.boundingBox;
			if (!BBBriefcase) {
				throw STD.errors.user('No bounding box for counter found');
			}
			const partitionsHeadsBusiness = app.component_configuration.productsComponents.find(x => x.type ===
				'partitionsHead' &&
				x.SKU ===
				'partitionsHead-ALeft');
			if (!partitionsHeadsBusiness) {
				throw STD.errors.user('No partitions Heads Business found in standing furniture');
			}
			const BBPartitionsHeadsbusiness = partitionsHeadsBusiness.boundingBox;
			if (!BBPartitionsHeadsbusiness) {
				throw STD.errors.user('No bounding box for counter found');
			}
			if (layoutId === 'shape-no-wall') {
				return null;
			} else if (layoutId === 'shape-back-left') {
				if (item === 'firstChair') {
					return mtx([
						-x / 2 + BBArchRight.depth / 2 - BBTable.width * 2 / 3,
						0,
						-z / 2 + BBArchRight.width / 2 - BBTable.depth / 3
					], 60);
				} else if (item === 'secondChair') {
					return mtx([
						-x / 2 + BBArchRight.depth / 2 + BBTable.width * 2 / 3,
						0,
						-z / 2 + BBArchRight.width / 2
					], 270);
				} else if (item === 'thirdChair') {
					return mtx([
						-x / 2 + BBArchRight.depth / 2,
						0,
						-z / 2 + BBArchRight.width / 2 + BBTable.depth * 2 / 3
					], 180);
				} else if (item === 'table') {
					return mtx([ -x / 2 + BBArchRight.depth / 2, 0, -z / 2 + BBArchRight.width / 2 ], 0);
				} else if (item === 'highTable') {
					return mtx([ x / 8, 0, z / 8 ], 0);
				} else if (item === 'firstStool') {
					return mtx([ x / 8 - BBHighTable.width * 2 / 3, 0, z / 8 - BBHighTable.depth * 2 / 3 ], 45);
				} else if (item === 'secondStool') {
					return mtx([ x / 8 - BBHighTable.width * 2 / 3, 0, z / 8 + BBHighTable.depth * 2 / 3 ], 135);
				} else if (item === 'thirdStool') {
					return mtx([ x / 8 + BBHighTable.width, 0, z / 8 ], 270);
				} else if (item === 'fourthStool') {
					return mtx([ x / 2 - BBCounter.width / 2 - 0.25, 0, z / 2 - BBCounter.depth * 1.5 - 0.2 ], 0);
				} else if (item === 'trash') {
					return mtx([ x / 2 - BBCounter.width - 0.25 - 2 * BBTrash.width / 3, 0, z / 2 - BBTrash.depth / 2 - 0.2 ], 0);
				}else if (item === 'briefcase') {
					return mtx(
						[ -x / 2 + BBPartitionsHeadsbusiness.depth + BBBriefcase.width / 2, 0, z / 2 - BBBriefcase.depth / 2 ],
						0
					);
				}
			} else if (layoutId === 'shape-back') {
				if (item === 'highTable') {
					return mtx([ x / 8, 0, z / 8 ], 0);
				} else if (item === 'firstStool') {
					return mtx([ x / 8 - BBHighTable.width * 2 / 3, 0, z / 8 - BBHighTable.depth * 2 / 3 ], 45);
				} else if (item === 'secondStool') {
					return mtx([ x / 8 - BBHighTable.width * 2 / 3, 0, z / 8 + BBHighTable.depth * 2 / 3 ], 135);
				} else if (item === 'thirdStool') {
					return mtx([ x / 8 + BBHighTable.width, 0, z / 8 ], 270);
				} else if (item === 'fourthStool') {
					return mtx([ x / 2 - BBCounter.width / 2 - 0.25, 0, z / 2 - BBCounter.depth * 1.5 - 0.2 ], 0);
				} else if (item === 'briefcase') {
					return mtx([ -x / 2 + BBBriefcase.width / 2, 0, z / 2 - BBBriefcase.depth / 2 ], 0);
				} else if (item === 'trash') {
					return mtx([x / 2 - BBCounter.width - 0.25 - 2 * BBTrash.width / 3,	0, z / 2 - BBTrash.depth / 2 - 0.2], 0);
				}
			} else if (layoutId === 'shape-back-right') {
				if (item === 'firstChair') {
					return mtx([
						x / 2 - BBArchRight.depth / 2 + BBTable.width * 2 / 3,
						0,
						-z / 2 + BBArchRight.width / 2 - BBTable.depth / 3
					], 315);
				} else if (item === 'secondChair') {
					return mtx([ x / 2 - BBArchRight.depth / 2 - BBTable.width * 2 / 3, 0, -z / 2 + BBArchRight.width / 2 ], 90);
				} else if (item === 'thirdChair') {
					return mtx([ x / 2 - BBArchRight.depth / 2, 0, -z / 2 + BBArchRight.width / 2 + 2 * BBTable.depth / 3 ], 180);
				} else if (item === 'table') {
					return mtx([ x / 2 - BBArchRight.depth / 2, 0, -z / 2 + BBArchRight.width / 2 ], 0);
				} else if (item === 'highTable') {
					return mtx([ -x / 8, 0, z / 8 ], 0);
				} else if (item === 'firstStool') {
					return mtx([ -x / 8 + BBHighTable.width * 2 / 3, 0, z / 8 - BBHighTable.depth * 2 / 3 ], 315);
				} else if (item === 'secondStool') {
					return mtx([ -x / 8 + BBHighTable.width * 2 / 3, 0, z / 8 + BBHighTable.depth * 2 / 3 ], 225);
				} else if (item === 'thirdStool') {
					return mtx([ -x / 8 - BBHighTable.width, 0, z / 8 ], 90);
				} else if (item === 'fourthStool') {
					return mtx([ -x / 2 + BBCounter.width / 2 + 0.25, 0, z / 2 - BBCounter.depth * 1.5 - 0.2 ], 0);
				} else if (item === 'trash') {
					return mtx([-x / 2 + BBCounter.width * 1.5 - 0.25 + 2 * BBTrash.width / 3, 0, z / 2 - BBTrash.depth / 2 - 0.2], 0);
				} else if (item === 'briefcase') {
					return mtx(
						[ x / 2 - BBPartitionsHeadsbusiness.depth - BBBriefcase.width / 2, 0, z / 2 - BBBriefcase.depth / 2 ],
						0
					);
				}
			} else if (layoutId === 'shape-left-back-right') {
				if (item === 'firstChair') {
					return mtx([
						-x / 2 + 2 * BBArchRight.depth / 3 - BBTable.width * 2 / 3,
						0,
						-z / 2 + BBArchRight.width / 3 - BBTable.depth / 3
					], 60);
				} else if (item === 'secondChair') {
					return mtx([ -x / 2 + 2 * BBArchRight.depth / 3 + BBTable.width * 2 / 3, 0, -z / 2 + BBArchRight.width / 3 ], 270);
				} else if (item === 'thirdChair') {
					return mtx([ -x / 2 + 2 * BBArchRight.depth / 3, 0, -z / 2 + BBArchRight.width / 3 + BBTable.depth * 2 / 3 ], 180);
				} else if (item === 'table') {
					return mtx([ -x / 2 + 2 * BBArchRight.depth / 3, 0, -z / 2 + BBArchRight.width / 3 ], 0);
				} else if (item === 'highTable') {
					return mtx([ x / 6, 0, z / 6 ], 0);
				} else if (item === 'firstStool') {
					return mtx([ x / 6 - BBHighTable.width * 2 / 3, 0, z / 6 - BBHighTable.depth * 2 / 3 ], 45);
				} else if (item === 'secondStool') {
					return mtx([ x / 6 - BBHighTable.width * 2 / 3, 0, z / 6 + BBHighTable.depth * 2 / 3 ], 135);
				} else if (item === 'thirdStool') {
					return mtx([ x / 6 + BBHighTable.width, 0, z / 6 ], 270);
				} else if (item === 'fourthStool') {
					return mtx([ -x / 2 + BBCounter.width + 0.25, 0, z / 2 - BBCounter.depth * 1.5 - 0.2 ], 0);
				} else if (item === 'trash') {
					return mtx([x / 2 - BBCounter.width * 1.5 - 2 * BBTrash.width / 3 - 0.25, 0, z / 2 - BBTrash.depth / 2 - 0.2], 0);
				} else if (item === 'briefcase') {
					return mtx(
						[ x / 2 - BBPartitionsHeadsbusiness.depth - BBBriefcase.width / 2, 0, z / 2 - BBBriefcase.depth / 2 ],
						0
					);
				}
			}
		} else if (product.id === 'siae') {
			const briefcase = app.component_configuration.productsComponents.find(x => x.type ===
				'@furniture' &&
				x.SKU ===
				'furniture-briefcase-siae');
			if (!briefcase) {
				throw STD.errors.user('No briefcase furniture found');
			}
			const BBBriefcase = briefcase.boundingBox;
			if (!BBBriefcase) {
				throw STD.errors.user('No bounding box for counter found');
			}
			const partitionsHeadsSIAE = app.component_configuration.productsComponents.find(x => x.type ===
				'partitionsHead' &&
				x.products.includes('siae'));
			if (!partitionsHeadsSIAE) {
				throw STD.errors.user('No partitions Heads SIAE found in standing furniture!');
			}
			const BBPartitionsHeadsSIAE = partitionsHeadsSIAE.boundingBox;
			if (!BBPartitionsHeadsSIAE) {
				throw STD.errors.user('No bounding box for partitions heads found!');
			}
			const tabouretSIAE = app.component_configuration.productsComponents.find(x => x.type ===
				'@furniture' &&
				x.SKU ===
				'furniture-seat-c');
			if (!tabouretSIAE) {
				throw STD.errors.user('No tabouret siae found in standing furniture');
			}
			const BBTabouretSIAE = tabouretSIAE.boundingBox;
			if (!BBTabouretSIAE) {
				throw STD.errors.user('No bounding box for Tabouret SIAE found');
			}
			if (layoutId === 'shape-no-wall') {
				return null;
			} else if (layoutId === 'shape-back-left') {
				if (item === 'highTable') {
					return mtx([ x / 8, 0, -z / 8 ], 0);
				} else if (item === 'firstStool') {
					return mtx([
						x / 8 - BBHighTable.width / 3 - BBTabouretSIAE.width / 2,
						0,
						-z / 8 - BBHighTable.depth / 3 + BBTabouretSIAE.depth / 2
					], 45);
				} else if (item === 'secondStool') {
					return mtx([
						x / 8 - BBHighTable.width / 3 + BBTabouretSIAE.width / 2,
						0,
						-z / 8 + BBHighTable.depth / 3 + BBTabouretSIAE.depth / 2
					], 135);
				} else if (item === 'thirdStool') {
					return mtx([
						x / 8 + BBHighTable.width - BBTabouretSIAE.width / 2,
						0,
						-z / 8 - BBTabouretSIAE.depth / 2
					], 270);
				} else if (item === 'fourthStool') {
					return mtx([
						x / 2 - BBCounter.width / 2 - 0.25 - BBTabouretSIAE.width / 2,
						0,
						z / 2 - BBCounter.depth * 1.5
					], 0);
				} else if (item === 'trash') {
					return mtx([ x / 2 - BBCounter.width - 0.25 - 2 * BBTrash.width / 3, 0, z / 2 - BBTrash.depth / 2 - 0.2 ], 0);
				} else if (item === 'briefcase') {
					return mtx([
						x / 2 - BBCounter.width - 0.25 - 5 * BBTrash.width / 3 - BBBriefcase.width / 2,
						0,
						z / 2 - BBBriefcase.depth - 0.2
					], 0);
				} else if (item === 'plant') {
					return mtx([ x / 2 - 0.5, 0, -z / 2 + 0.5 ], 0);
				}
			} else if (layoutId === 'shape-back') {
				if (item === 'highTable') {
					return mtx([ x / 8, 0, -z / 8 ], 0);
				} else if (item === 'firstStool') {
					return mtx([
						x / 8 - BBHighTable.width / 3 - BBTabouretSIAE.width / 2,
						0,
						-z / 8 - BBHighTable.depth / 3 + BBTabouretSIAE.depth / 2
					], 45);
				} else if (item === 'secondStool') {
					return mtx([
						x / 8 - BBHighTable.width / 3 + BBTabouretSIAE.width / 2,
						0,
						-z / 8 + BBHighTable.depth / 3 + BBTabouretSIAE.depth / 2
					], 135);
				} else if (item === 'thirdStool') {
					return mtx([
						x / 8 + BBHighTable.width - BBTabouretSIAE.width / 2,
						0,
						-z / 8 - BBTabouretSIAE.depth / 2
					], 270);
				} else if (item === 'fourthStool') {
					return mtx([
						x / 2 - BBCounter.width / 2 - 0.25 - BBTabouretSIAE.width / 2,
						0,
						z / 2 - BBCounter.depth * 1.5
					], 0);
				} else if (item === 'trash') {
					return mtx([
						x / 2 - BBCounter.width - 0.25 - 2 * BBTrash.width / 3,
						0,
						z / 2 - BBTrash.depth / 2 - 0.2
					], 0);
				} else if (item === 'briefcase') {
					return mtx([
						x / 2 - BBCounter.width - 0.25 - 5 * BBTrash.width / 3 - BBBriefcase.width / 2,
						0,
						z / 2 - BBBriefcase.depth - 0.2
					], 0);
				} else if (item === 'plant') {
					return mtx([ x / 2 - 0.5, 0, -z / 2 + 0.5 ], 0);
				}
			} else if (layoutId === 'shape-back-right') {
				if (item === 'highTable') {
					return mtx([ -x / 8, 0, -z / 8 ], 0);
				} else if (item === 'firstStool') {
					return mtx(
						[ -x / 8 + BBHighTable.width / 3 + BBTabouretSIAE.depth / 3, 0, -z / 8 - BBTabouretSIAE.width / 2 ],
						270
					);
				} else if (item === 'secondStool') {
					return mtx([
						-x / 8 - BBHighTable.width / 3 + (Math.sqrt(BBTabouretSIAE.width ** 2 + BBTabouretSIAE.depth ** 2) / 2),
						0,
						-z / 8 + BBHighTable.depth / 3 + BBTabouretSIAE.depth / 2
					], 135);
				} else if (item === 'thirdStool') {
					return mtx([
						-x / 8 - BBHighTable.width / 3 - BBTabouretSIAE.width / 2,
						0,
						-z / 8 - BBHighTable.depth / 3
					], 30);
				} else if (item === 'fourthStool') {
					return mtx([
						-x / 2 + BBCounter.width - 0.25 - BBTabouretSIAE.width / 2,
						0,
						z / 2 - BBCounter.depth * 1.5
					], 0);
				} else if (item === 'trash') {
					return mtx([
						-x / 2 + BBCounter.width * 1.5 - 0.25 + 2 * BBTrash.width / 3,
						0,
						z / 2 - BBTrash.depth / 2 - 0.2
					], 0);
				} else if (item === 'briefcase') {
					return mtx([
						-x / 2 + BBCounter.width * 1.5 - 0.25 + 5 * BBTrash.width / 3 + BBBriefcase.width / 2,
						0,
						z / 2 - BBBriefcase.depth - 0.2
					], 0);
				} else if (item === 'plant') {
					return mtx([ -x / 2 + 0.5, 0, -z / 2 + 0.5 ], 0);
				}
			} else if (layoutId === 'shape-left-back-right') {
				if (surface > 24) {
					if (item === 'highTable') {
						return mtx([ x / 8, 0, -z / 8 ], 0);
					} else if (item === 'firstStool') {
						return mtx([
							x / 8 - BBHighTable.width / 3 - BBTabouretSIAE.width / 2,
							0,
							-z / 8 - BBHighTable.depth / 3 + BBTabouretSIAE.depth / 2
						], 45);
					} else if (item === 'secondStool') {
						return mtx([
							x / 8 - BBHighTable.width / 3 + BBTabouretSIAE.width / 2,
							0,
							-z / 8 + BBHighTable.depth / 3 + BBTabouretSIAE.depth / 2
						], 135);
					} else if (item === 'thirdStool') {
						return mtx([
							x / 8 + BBHighTable.width - BBTabouretSIAE.width / 2,
							0,
							-z / 8 - BBTabouretSIAE.depth / 2
						], 270);
					} else if (item === 'fourthStool') {
						return mtx([
							x / 2 - BBCounter.width - BBTabouretSIAE.width / 2 - 0.25,
							0,
							z / 2 - BBCounter.depth * 1.5
						], 0);
					} else if (item === 'trash') {
						return mtx([
							x / 2 - BBCounter.width * 1.5 - 2 * BBTrash.width / 3 - 0.25,
							0,
							z / 2 - BBTrash.depth / 2 - 0.2
						], 0);
					} else if (item === 'briefcase') {
						return mtx([
							x / 2 - 0.25 - BBCounter.width / 4,
							0,
							z / 2 - BBBriefcase.depth - 0.2
						], 0);
					} else if (item === 'plant') {
						return mtx([ -x / 2 + 0.5, 0, z / 2 - 0.5 ], 0);
					}
				} else {
					if (item === 'firstStool') {
						return mtx([
							-BBHighTable.width / 3 - BBTabouretSIAE.width / 2,
							0,
							-BBHighTable.depth / 3 + BBTabouretSIAE.depth / 2
						], 45);
					} else if (item === 'secondStool') {
						return mtx([
							-BBHighTable.width / 3 + BBTabouretSIAE.width / 2,
							0,
							+BBHighTable.depth / 3 + BBTabouretSIAE.depth / 2
						], 135);
					} else if (item === 'thirdStool') {
						return (ViewerComponent.mtx([
							+BBHighTable.width - BBTabouretSIAE.width / 2,
							0,
							-BBTabouretSIAE.depth / 2
						], [ 1, 1, 1 ], 270));
					} else if (item === 'fourthStool') {
						return mtx([
							x / 2 - BBCounter.width - BBTabouretSIAE.width / 2 - 0.25,
							0,
							z / 2 - BBCounter.depth * 1.5
						], 0);
					} else if (item === 'trash') {
						return mtx([
							x / 2 - BBCounter.width * 1.5 - 2 * BBTrash.width / 3 - 0.25,
							0,
							z / 2 - BBTrash.depth / 2 - 0.2
						], 0);
					} else if (item === 'briefcase') {
						return mtx([
							x / 2 - 0.25 - BBCounter.width / 4,
							0,
							z / 2 - BBBriefcase.depth - 0.2
						], 0);
					}
				}
			}
		}
		return null;
	};

	async insert() {
		if (
			app.hasThisModuleUsed('standing-customerMode') &&
			(app.parameters.mode === 'client')
		)
		{
			if (app.viewer.planner) {
				const product = app.viewer.categories.map(x => x.products).
				flat().
				find(x => x.SKU === 'furniture-plant-siae');
				if (product) {
					if (product.instances.size) {
						const mod = app.modules.used.find(x => x.id === 'viewer-planner-furniture-editor');
						if (mod && mod.component) {
							const c = mod.component.component_find('@:menu').
							component_outerChilds.
							map(x => x.component_find('@:content')).
							map(x => x.component_outerChilds.find(x => x.id === 'furniture-plant-siae')).
							filter(x => x)[ 0 ];
							if (c) {
								(<CM.DOMComponent<any, any, any>> c).component_DOM.classList.add('limitReached');
								(<CM.DOMComponent<any, any, any>> c).component_DOM.title =
									app.currentLanguage === 'fr' ? 'Limité à un seul exemplaire' : 'Limited to one copy';
							}
						}
					}
				}
			}
			return;
		}
		// insert nodes
		const product = app.currentProduct;
		if (!product || !app.viewer.planner) {
			this.component_throwUserError('');
		}
		if (product.id === 'confort' || product.id === 'prestige') {
			return;
		}
		await this.remove();
		const plannerFurniture = app.modules.used.find(x => x.id === 'viewer-planner-furniture-editor');
		if (!plannerFurniture) {
			this.component_throwUserError('');
		}
		const plannerFurnitureComponent = <PlannerFurnitureEditorNS.Component> plannerFurniture.component;
		if (!plannerFurnitureComponent) {
			this.component_throwUserError('');
		}
		const plannerFurnitureCategories = plannerFurnitureComponent.categories;
		if (!plannerFurnitureCategories) {
			this.component_throwUserError('');
		}
		const planner = app.viewer.planner;
		if (!planner) {
			this.component_throwUserError('');
		}
		const batch : ViewerComponent.INative_setProductNodesInstancesMatrices_descriptor = [];
		const listBusinessItem = [
			{ id : 'seat-b', name : 'firstStool' },
			{ id : 'seat-b', name : 'secondStool' },
			{ id : 'seat-b', name : 'thirdStool' },
			{ id : 'seat-b', name : 'fourthStool' },
			{ id : 'seat-a', name : 'firstChair' },
			{ id : 'seat-a', name : 'secondChair' },
			{ id : 'seat-a', name : 'thirdChair' },
			{ id : 'table', name : 'highTable' },
			{ id : 'table-basse', name : 'table' },
			{ id : 'briefcase-business', name : 'briefcase' },
			{ id : 'trash', name : 'trash' }
		];
		const listSIAEItem = [
			{ id : 'seat-c', name : 'firstStool' },
			{ id : 'seat-c', name : 'secondStool' },
			{ id : 'seat-c', name : 'thirdStool' },
			{ id : 'seat-c', name : 'fourthStool' },
			{ id : 'table', name : 'highTable' },
			{ id : 'briefcase-siae', name : 'briefcase' },
			{ id : 'trash', name : 'trash' },
			{ id : 'plant-siae', name : 'plant' }
		];
		for (const cat of plannerFurnitureCategories) {
			for (const pro of cat.products) {
				if (product.id === 'business') {
					let i = 1;
					const addItem = listBusinessItem.filter(x => x.id === pro.plannerProduct.SKU.replace('furniture-', ''));
					for (const x of addItem) {
						const matrix = this.computeMatrix(x.name);
						if (!matrix) {
							continue;
						}
						const item = await pro.plannerProduct.instantiate({
							rootLocalId : app.viewer.globalLocalId,
							appendType : 'insert',
							basketPart : [],
							basketUseDynamicTitleBinding : false,
							metadata : {
								id :              pro.plannerProduct.SKU + '-' + i,
								isFurnitureAuto : true
							}
						});
						if (!item) {
							this.component_throwUserError('');
						}
						item.setName(pro.plannerProduct.SKU);
						batch.push({ localId : item.localId, matrix });
						i += 1;
					}
				} else {
					let i = 1;
					const addItem = listSIAEItem.filter(x => x.id === pro.plannerProduct.SKU.replace('furniture-', ''));
					for (const x of addItem) {
						const matrix = this.computeMatrix(x.name);
						if (!matrix) {
							continue;
						}
						const item = await pro.plannerProduct.instantiate({
							rootLocalId : app.viewer.globalLocalId,
							appendType : 'insert',
							basketPart : [],
							basketUseDynamicTitleBinding : false,
							metadata : {
								id :              pro.plannerProduct.SKU + '-' + i,
								isFurnitureAuto : true
							}
						});
						if (!item) {
							this.component_throwUserError('');
						}
						item.setName(pro.plannerProduct.SKU);
						batch.push({ localId : item.localId, matrix });
						i += 1;
					}
				}
			}
		}
		await app.viewer.batch([ [ 'setProductNodesInstancesMatrices', batch ] ]);
	};

	async remove() {
		if (!app.viewer.planner) {
			this.component_throwLibraryError('');
		}
		for (const xx of
			Array.from(app.viewer.safe.value.productInstances).
			filter(x => x.metadata.isFurnitureAuto || x.metadata.isUserInserted))
		{
			await xx.delete();
		}
	};

	constructor(
		descriptor : ConstructorParameters<typeof CM.Component>[0],
		configuration : IStandingFurnitureComponentConfiguration
	)
	{
		super(descriptor, configuration);
	};
};
export namespace NS {
	export const Component = StandingFurnitureComponent;
	export type Component = StandingFurnitureComponent;
	export type Configuration = IStandingFurnitureComponentConfiguration;
}

CM.declare({
	id :   'standing-furniture',
	type : StandingFurnitureComponent
});
